import React, { ComponentPropsWithoutRef } from "react"
import { ShipDeckPlan } from "@silversea-ssc/ui-components-react"
import { getSuiteFeatureLabels } from "../ShipDetails/labels"
import { getShipDirectionLabels } from "./labels"

type Props = Omit<ComponentPropsWithoutRef<typeof ShipDeckPlan>, "labels"> & { showFeatures?: boolean }

const LocalizedShipDeckPlan: React.FC<React.PropsWithChildren<Props>> = ({ showFeatures = true, ...props }) => {
    return (
        <ShipDeckPlan
            {...props}
            labels={{
                ...getShipDirectionLabels(),
                ...(showFeatures ? getSuiteFeatureLabels() : {}),
            }}
        />
    )
}

export default LocalizedShipDeckPlan
